import type { GradebookResourceRow } from "@/types/models";

export interface WorkspaceTotal {
  earned: number; // Σ entered resource points (instructor); released-only for students (server-redacted)
  possible: number; // Σ point values
  override: number | null; // instructor's final-grade override (null = computed)
  points: number; // override ?? earned (numerator)
  outOf: number; // possible (denominator)
  percent: number | null;
  gradedCount: number;
  overridden: boolean;
}

// Model A — points-based: each resource is worth `weight` points; the
// student earns `points` of those (rubric-default or override). The total
// is the straight sum of earned points, out of the sum of point values —
// unless the instructor has overridden the final grade, which replaces
// the computed sum. (Students only see released points — the server nulls
// out unreleased ones — so the same code yields their "grade so far".)
export const computeWorkspaceTotal = (
  rows: GradebookResourceRow[],
  override: number | null
): WorkspaceTotal => {
  let earned = 0;
  let possible = 0;
  let gradedCount = 0;
  for (const r of rows) {
    possible += r.weight ?? 0;
    if (r.points != null) {
      earned += r.points;
      gradedCount++;
    }
  }
  const points = override != null ? override : earned;
  return {
    earned,
    possible,
    override,
    points,
    outOf: possible,
    percent: possible > 0 ? Math.round((points / possible) * 100) : null,
    gradedCount,
    overridden: override != null,
  };
};
